import script from "./EnableNotificationsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnableNotificationsPage.vue?vue&type=script&setup=true&lang=ts"

import "./EnableNotificationsPage.vue?vue&type=style&index=0&id=30d79ba4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30d79ba4"]])

export default __exports__